module.exports = __webpack_public_path__ + "static/img/pro-img.2a01169.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pro-img.png
// module id = JhHx
// module chunks = 0